import React from 'react';
import { usePlan } from '../../plan/usePlan';
import ProTeaser from './ProTeaser';

/**
 * Renders the real page for entitled providers; otherwise a static synthetic
 * teaser (design §3). Children are NOT mounted when gated, so a gated page
 * never fetches its data.
 */
export default function ProGate({ providerData, feature, onUpgradeClick, children }) {
  const { has } = usePlan(providerData);
  if (has(feature)) return children;
  return <ProTeaser feature={feature} onUpgradeClick={onUpgradeClick} />;
}
